import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, Institution } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const GROUP_URL = '/ris/groups/v1';

export interface ParamsGetGroup {
  active?: boolean;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  offset?: number;
  sort_field?: '' | 'updated_at';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
  user_ids?: string[];
}
export interface ResponseGetGroups extends DefaultResponse {
  data: {
    active: boolean;
    created_at: string;
    creator_id: string;
    id: string;
    institution_ids: string[];
    institutions: Institution[];
    name: string;
    updated_at: string;
  }[];
}
export const getGroups = async (params: ParamsGetGroup) => {
  const response = (await api({
    url: GROUP_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetGroups>;

  return response.data;
};

export interface ParamsCreateGroup {
  active: boolean;
  name: string;
  user_ids: string[];
}
export const createGroup = async (data: ParamsCreateGroup) => {
  const response = (await api({
    url: GROUP_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateGroup {
  active: boolean;
  name: string;
  user_ids: string[];
}
export const updateGroup = async (id: string, data: ParamsUpdateGroup) => {
  const response = (await api({
    url: `${GROUP_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteGroup = async (id: string) => {
  const response = (await api({
    url: `${GROUP_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
